import { Container, DisplayObject } from "pixi.js";

export type Bounds = { width: number, height: number };

export function implementBoundedContainer(asset: Container<DisplayObject>, maxSize: Bounds, update: boolean = true): BoundedContainer {
    const newContainer = new BoundedContainer(maxSize);
    newContainer.x = asset.x;
    newContainer.y = asset.y;
    asset.x = asset.y = 0;

    if (asset.parent) {
        asset.parent.addChild(newContainer);
        newContainer.addChild(asset);
    }

    if (update) {

        newContainer.update();
    }

    return newContainer;
}

export class BoundedContainer extends Container {
    _maxSize: Bounds;

    set maxSize(value: Bounds) {
        this._maxSize = value;
    }

    get maxSize() {
        return this._maxSize;
    }

    constructor(maxSize: Bounds) {
        super();
        this._maxSize = maxSize;
    }

    update() {
        this.scale.set(1);
        const heightRatio = Math.max(1, this.width / this._maxSize.width);
        const widthRatio = Math.max(1, this.height / this._maxSize.height);
        const ratio = Math.max(1, widthRatio, heightRatio);
        this.scale.set(1 / ratio, 1 / ratio);
    }
}